import { render, staticRenderFns } from "./RequestPasswordReset.vue?vue&type=template&id=9c71c606&scoped=true&"
import script from "./RequestPasswordReset.vue?vue&type=script&lang=js&"
export * from "./RequestPasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c71c606",
  null
  
)

export default component.exports